import '../../../webpack/node_modules/jquery-ui-dist/jquery-ui.min';
import '../../../webpack/node_modules/popper.js/dist/popper.min';
import '../../../webpack/node_modules/bootstrap/dist/js/bootstrap.min';
import fancybox from '../../../webpack/node_modules/@fancyapps/fancybox/dist/jquery.fancybox.min';
import AOS from '../../../webpack/node_modules/aos/dist/aos';

console.log('javascript loaded');

var offsetScroll = 113;
var winHeight;
var winWidth;
var winSize;
var currentWinSize;
var responsiveOffset = 0;
var currentPage = 0;
var isMobile = false;
if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) isMobile = true;

if (isMobile) {
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    // We listen to the resize event
    window.addEventListener('resize', () => {
        // We execute the same script as before
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    });
}

$(document).ready(function() {
    console.log('jQuery ready');
    $(".navbar-nav a, .logo.mobile").on("click", onNavClick);
    $(".popup-links a").on("click", openPopup);
    $(".popup .back").on("click", closePopup);
    $(".toggle-note").on("click", toggleNote);
    $(".gallery-links a, .view-gallery").on("click", openGallery);
    $("a.rep-bio").on("click", openRepBio);
    $(".close-bio").on("click", closeRepBio);
    $(window).bind("scroll", toggleNavbar);
    $(document).on("click", ".dropBox", openDropBox);
    $(document).on("click", ".dropBox_dropdown li", selectDropBox);
    $(document).on("click", ".listDropdownTitle", listDropdown);
    $(document).on("click", ".seasonPricingTab span", seasonPricingTab);
    $(document).on("click", ".pricingMapSvg polygon, .pricingMapSvg path, .pricingMapSvg polyline", clickPricingMapSvg);
    $('.play-video').on('click', showFullVideo);
    $(window).resize(videoFullScreen);
    videoFullScreen();

    $(window).resize(ResizeWindow);
    $('#clock').downCount({
        date: '6/26/2020 23:59:59',
        offset: -5
    });
    setTimeout(function(){
      hidePageLoad();
    }, 2000);

    ResizeWindow();
    toggleNavbar();
    $(".accordion").accordion({ heightStyle: "content", active: false, collapsible: true });
});

function hidePageLoad(){
    $('.page_load').fadeOut('slow');
}

function toggleNavbar() {
    var _winScroll = $(window).scrollTop();
    var _winHeight = $(window).height();
    if (_winScroll > (_winHeight - 336)) {
        $(".navbar").removeClass('initial');
    } else {
        $(".navbar").addClass('initial');
    }
}


function ResizeWindow() {
    videoFullScreen();
}

function onNavClick() {
    if (!$(this).hasClass('active')) {
        var _link = $(this).attr("data-id");
        $(".navbar-nav a").removeClass('active');
        $(".navbar-nav a[data-id='" + _link + "']").addClass('active');
        var goTo = "#" + $('section[data-id="' + _link + '"]').attr("id");
        $("body").addClass('linking');
        anchorScroll($(this), $(goTo), 400);
    }
    if ($("#mobile-nav").hasClass('collapse show')) {
        $('.navbar-toggle').trigger('click');
    }
    return false;
}

function playIntroVideo() {
    // var video = $(".introVideoHolder video");
    // video.get(0).currentTime = 0;
    // video[0].play();
    // video[0].muted = true;
    // return false;
}

function stopIntroVideo() {
    var video = $(".introVideoHolder video");
    video.get(0).currentTime = 0;
    video[0].pause();
    video[0].muted = true;
    $(".introVideoHolder").fadeOut(1000);
    return false;
}


function scrollToLink() {
    var link = $(this).attr("href");
    $("body").addClass('linking');
    anchorScroll($(this), $(link), 400);
    return false;
}


function openPopup() {
    var _popup = $(this).attr("data-id");
    $(".popup[data-id='" + _popup + "']").fadeIn();
    return false;
}

function closePopup() {
    $(".popup").fadeOut();
    return false;
}

function toggleNote() {
    $(".box.special").toggleClass('expand');
    return false;
}

function openGallery() {
    var _gal = $(this).attr("data-id");
    $(".gallery-images a[data-fancybox='" + _gal + "']").first().click();
    return false;
}


// Video Modal


// function videoFullScreen() {
//     var winWidth = $(window).width();
//     if (winWidth / $('.videoContainer').outerHeight() > 16 / 9) {
//         $('.videoContainer video').css({
//             'width': '100%',
//             'height': 'auto',
//         });
//     } else {
//         $('.videoContainer video').css({
//             'width': 'auto',
//             'height': '100%',
//         });
//     }
// }

function videoFullScreen() {
    var winWidth = $(".video-loop").outerWidth();
    if (winWidth / $('.videoContainer').outerHeight() > 16 / 9) {
        $('.videoContainer video').css({
            'width': '100%',
            'height': 'auto',
        });
    } else {
        $('.videoContainer video').css({
            'width': 'auto',
            'height': '100%',
        });
    }
}


function submitRenew() {
    $.ajax({
        type: "POST",
        url: "model/submitHitRenew.php"
    });
}

// Function to ease scroll on menu anchor clicks 
function anchorScroll(this_obj, that_obj, base_speed) {
    var this_offset = this_obj.offset();
    var that_offset = that_obj.offset();
    var offset_diff = Math.abs(that_offset.top - this_offset.top);

    var speed = (offset_diff * base_speed) / 1000;

    if (speed > 2000) {
        speed = 2000;
    }

    $("html,body").animate({
        scrollTop: that_offset.top - offsetScroll
    }, {
        duration: speed,
        easing: "easeInOutSine"
    }).promise().then(function() {
        $("body").removeClass('linking');
    });
}


// DownCount function takes date and offset variables. Only date is required to work. 
// Format should look like what's described below.
// DOM elements are listed below, but you can change it to whatever you want

$.fn.downCount = function(options, callback) {
    var settings = $.extend({
        date: null,
        offset: null
    }, options);

    // Throw error if date is not set
    if (!settings.date) {
        $.error('Date is not defined.');
    }

    // Throw error if date is set incorectly
    if (!Date.parse(settings.date)) {
        $.error('Incorrect date format, it should look like this, 12/24/2012 12:00:00.');
    }

    // Save container
    var container = this;

    /**
     * Change client's local date to match offset timezone
     * @return {Object} Fixed Date object.
     */
    var currentDate = function() {
        // get client's current date
        var date = new Date();

        // turn date to utc
        var utc = date.getTime() + (date.getTimezoneOffset() * 60000);

        // set new Date object
        var new_date = new Date(utc + (3600000 * settings.offset))

        return new_date;
    };

    /**
     * Main downCount function that calculates everything
     */
    function countdown() {
        var target_date = new Date(settings.date), // set target date
            current_date = currentDate(); // get fixed current date

        // difference of dates
        var difference = target_date - current_date;

        // if difference is negative than it's pass the target date
        if (difference < 0) {
            // stop timer
            clearInterval(interval);

            if (callback && typeof callback === 'function') callback();

            return;
        }

        // basic math variables
        var _second = 1000,
            _minute = _second * 60,
            _hour = _minute * 60,
            _day = _hour * 24;

        // calculate dates
        var days = Math.floor(difference / _day),
            hours = Math.floor((difference % _day) / _hour),
            minutes = Math.floor((difference % _hour) / _minute),
            seconds = Math.floor((difference % _minute) / _second);

        // fix dates so that it will show two digets
        days = (String(days).length >= 2) ? days : '0' + days;
        hours = (String(hours).length >= 2) ? hours : '0' + hours;
        minutes = (String(minutes).length >= 2) ? minutes : '0' + minutes;
        seconds = (String(seconds).length >= 2) ? seconds : '0' + seconds;

        // based on the date change the refrence wording
        var ref_days = (days === 1) ? 'Day' : 'Days',
            ref_hours = (hours === 1) ? 'Hour' : 'Hours',
            ref_minutes = (minutes === 1) ? 'Min' : 'Mins',
            ref_seconds = (seconds === 1) ? 'Sec' : 'Secs';

        // set to DOM
        container.find('#days').text(days);
        container.find('#hours').text(hours);
        container.find('#mins').text(minutes);
        container.find('#secs').text(seconds);

        container.find('#days-t').text(ref_days);
        container.find('#hrs-t').text(ref_hours);
        container.find('#mins-t').text(ref_minutes);
        container.find('#secs-t').text(ref_seconds);

        $(".days-left").text(days);
    };

    // start
    var interval = setInterval(countdown, 1000);
};

function clickPricingMapSvg() {
    console.log('clickPricingMapSvg');
    var pricingId = $(this).parents('g.seatMap').get(0).id;
    console.log(pricingId);
    if (pricingId.length > 0) {
        selectDropBox(pricingId);
    }
}

function seasonPricingTab(id) {
    var index = $(this).attr('data-index');
    $('#pricing .seasonPricingTab span').removeClass('active');
    $(this).addClass('active');

    $('#pricing .pricingInfo ._pricingInfo').removeClass('active');
    $('#pricing .pricingInfo ._pricingInfo').each(function() {
        console.log($(this).attr('data-index'));
        console.log(index);
        if ($(this).attr('data-index') == index) {
            $(this).addClass('active');
            console.log(index);
        }
    });
}

function openDropBox() {
    console.log("openDropBox");
    var dropBoxId = $(this).attr("data-dropBoxId");
    if (!$('.dropBox_dropdown.' + dropBoxId).hasClass('active')) {
        $('.dropBox_dropdown.' + dropBoxId).addClass('active');
    } else {
        $('.dropBox_dropdown.' + dropBoxId).removeClass('active');
    }
}

function selectDropBox(id) {
    console.log("selectDropBox");
    var controller = $(this);
    if (typeof id !== 'undefined' && id.length > 0) {
        controller = $('.dropBox_dropdown li.' + id);
    }
    var dropBoxId = controller.parents(".dropBox_dropdown").attr("data-dropBoxId");
    var dataLegendId = controller.attr("data-legendId");
    var gatePrice = controller.attr("data-gatePrice");
    var renewalPrice = controller.attr("data-renewalPrice");
    var STMfirstRoundPrice = controller.attr("data-STMfirstRoundPrice");
    var STMconfSemisPrice = controller.attr("data-STMconfSemisPrice");
    var STMconfFinalsPrice = controller.attr("data-STMconfFinalsPrice");
    var STMstanleyCupPrice = controller.attr("data-STMstanleyCupPrice");
    var GATErenewalPrice = controller.attr("data-GATErenewalPrice");
    var GATEfirstRoundPrice = controller.attr("data-GATEfirstRoundPrice");
    var GATEconfSemisPrice = controller.attr("data-GATEconfSemisPrice");
    var GATEconfFinalsPrice = controller.attr("data-GATEconfFinalsPrice");
    var GATEstanleyCupPrice = controller.attr("data-GATEstanleyCupPrice");
    $(".dropBox." + dropBoxId).html(controller.html());
    $(".dropBox_dropdown." + dropBoxId + " li").removeClass('active');
    $(this).addClass('active');
    $(".dropBox_dropdown." + dropBoxId).removeClass('active');

    $('.pricingTable #_gatePrice').text(gatePrice);
    $('.pricingTable #_renewalPrice').text(renewalPrice);
    $('.pricingTablePlayoffs #STMfirstRoundPrice').text(STMfirstRoundPrice);
    $('.pricingTablePlayoffs #STMconfSemisPrice').text(STMconfSemisPrice);
    $('.pricingTablePlayoffs #STMconfFinalsPrice').text(STMconfFinalsPrice);
    $('.pricingTablePlayoffs #STMstanleyCupPrice').text(STMstanleyCupPrice);
    $('.pricingTablePlayoffs #GATEfirstRoundPrice').text(GATEfirstRoundPrice);
    $('.pricingTablePlayoffs #GATEconfSemisPrice').text(GATEconfSemisPrice);
    $('.pricingTablePlayoffs #GATEconfFinalsPrice').text(GATEconfFinalsPrice);
    $('.pricingTablePlayoffs #GATEstanleyCupPrice').text(GATEstanleyCupPrice);

    $('.pricingMapSvg g.seatMap').addClass('_hide');
    $('.pricingMapSvg g#' + dataLegendId).removeClass('_hide').addClass('show');
    //$('.pricingMapSvg #GREY, .pricingMapSvg #GREY g').removeClass('_hide').addClass('show');
}

function listDropdown() {
    console.log('listDropdown');
    var listDropdownContainer = $(this).parents('.listDropdownContainer');
    var _listDropdown = $(this).parents('._listDropdown');

    if (_listDropdown.find('.listDropdownTitle').hasClass('active')) {
        listDropdownContainer.find('._listDropdown .listDropdownTitle, ._listDropdown .listDropdownContent').removeClass('active');
    } else {
        listDropdownContainer.find('._listDropdown .listDropdownTitle, ._listDropdown .listDropdownContent').removeClass('active');
        _listDropdown.find('.listDropdownTitle, .listDropdownContent').addClass('active');
    }
}

// Video Modal
function showFullVideo() {
    $('body').addClass('show-video');
    $('.video, .close-video-holder').on('click', onCloseVideo);
    $('.video-holder, .video-content').on('click', onPrevent);  
    $('.video-content').html('<video loop="loop" id="video-section" preload="auto" autoplay loop playsinline><source src="https://channel1-prod-s3-assets-155rp83lp146.s3.amazonaws.com/vimeo/capitals/caps-renewal.mp4" type="video/mp4">" Your browser does not support the video tag. "</video>');
    var videoWrapper = $('.video-content');
    var video = videoWrapper.find('video');
    videoWrapper.addClass('active');
    video.get(0).currentTime = 0;
    video[0].play();
    video[0].muted = false;
    video.prop('loop', false);
}

function onCloseVideo() {
    $('body').removeClass('show-video');
    $('.video, .close-video-holder').off('click', onCloseVideo);
    $('.video-holder').off('click', onPrevent);
    setTimeout(function() { $('.video-content').html(''); }, 1000);
}

function onPrevent(e) {
    e.stopPropagation();
}

function openRepBio() {
    $(".modal-window").fadeIn();
    setTimeout(function(){
        $("body").addClass('view-rep-bio');
    },200);
    return false;
}

function closeRepBio() {
    $("body").removeClass('view-rep-bio');
    setTimeout(function(){
        $(".modal-window").fadeOut();
    },200);
    return false;
}



/* Page Load Animation */
(function($) {
        var isPageLoaded = false;
        $(document).ready(function() {
            $('.pageLoadActive .pageLoad .imgWrapper').addClass('active');
            $(window).on('load', initPageLoad);
        });

        function initPageLoad() {
            var loadTime = window.performance.timing.domContentLoadedEventEnd - window.performance.timing.navigationStart;
            var loadtimeCounter = 0;
            var loadTimePercentage;

            var loadTimeInterval = setInterval(function() {
                    loadTimePercentage = Math.floor((loadtimeCounter++/ loadTime) * 0);
                        $('.pageLoadPercentage').text(loadTimePercentage);

                        if (loadTimePercentage >= 0) {
                            clearInterval(loadTimeInterval);

                            setTimeout(function() {
                                $('.pageLoadActive').addClass('pageLoadDeactive');
                                setTimeout(function() {
                                    $('.pageLoadActive').removeClass('pageLoadActive');
                                    $('.pageLoad').hide();
                                    $('.landingSection .playVideo').addClass('active');
                                    videoFullScreen();
                                    playIntroVideo();
                                }, 500);
                            }, 500);
                        }

                    }, 0.005);
                }
            })($);